enum DecisionStatus {
  CREATED = 'CREATED',
}

export default DecisionStatus
